// icon.js
import React, { useEffect, useState } from 'react';
import IcoMoon from 'react-icomoon';

const Icon = ({ ...props }) => {
  const [iconSet, setIconSet] = useState(null);
  useEffect(() => {
    import('../../selection.json').then(icons => {
      setIconSet(icons);
    });
  }, []);
  if (!iconSet) return null;
  return <IcoMoon iconSet={iconSet} {...props} />;
};

export default Icon;
